<script>
import {defineComponent} from 'vue'
import {ElMessage} from "element-plus";
import {customerTypes} from "@/utils/static-values";

export default defineComponent({
  name: "CustomerForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null,
        tin: null,
        type: null,
      },
      rules: {
        title: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        tin: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        type: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ]
      }
    }
  },
  methods: {
    customerTypes() {
      return customerTypes
    },
    getCustomerById() {
      this.loading = true;
      this.$http.get(`api/v1/customers/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          let http;
          if (this.form.id) {
            http = this.$http.put(`api/v1/customers/${this.form.id}`, this.form)
          } else {
            http = this.$http.post(`api/v1/customers`, this.form)
          }
          http.then(() => {
            this.$router.go(-1);
          })
              .catch((err) => {
                ElMessage.error(
                    err.response.data.message || `Hatolik qayta urinib ko'ring`
                );
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getCustomerById()
    }
  }
})
</script>

<template>
  <p style="font-size: 18px" class="pb-8">
    {{ form.id ? "Taxrirlash" : `Qo'shish` }}
  </p>
  <el-row class="add-news">
    <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="8">
      <el-form
          label-position="top"
          v-loading="loading"
          ref="form"
          :rules="rules"
          :model="form"
      >
        <el-form-item label="Buyurtmachi nomi" prop="title">
          <el-input style="width: 100%" size="large" v-model="form.title" type="text"/>
        </el-form-item>
        <el-form-item label="Inn" prop="tin">
          <el-input style="width: 100%" size="large" v-model="form.tin" type="number"/>
        </el-form-item>
        <el-form-item label="Turini tanlang" prop="type">
          <el-select
              style="width: 100%"
              v-model="form.type"
              size="large"
              placeholder="Tanlang"
          >
            <el-option
                v-for="type in customerTypes()"
                :value="type.value"
                :label="type.label"
                :key="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="mt-15 text-right">
          <el-button
              @click="$router.go(-1)"
              class="el-button el-button--danger"
          >
            Bekor qilish
          </el-button>
          <el-button type="primary" @click="submitForm"
          >Saqlash
          </el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<style scoped>

</style>
